import React from 'react';
import '../styles/Integrations.css';

function Integrations() {
  return (
    <section id="integrations" className="integrations section">
      <div className="container">
        <div className="integrations-content">
          <div className="coming-soon-icon">🔌</div>
          <h2 className="coming-soon-title">Integrations Coming Soon</h2>
          <p className="coming-soon-text">
            We're working on seamless integrations with your favorite ATS platforms and job boards.
            Stay tuned for updates!
          </p>
          <p className="integration-contact">
            Need a specific integration? Contact our team at{' '}
            <a href="mailto:integration@fortif.app">integration@fortif.app</a>
          </p>
          <div className="integration-logos">
            <div className="integration-badge">Greenhouse</div>
            <div className="integration-badge">Lever</div>
            <div className="integration-badge">Workday</div>
            <div className="integration-badge">LinkedIn</div>
            <div className="integration-badge">Indeed</div>
            <div className="integration-badge">More...</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Integrations;
